import { Component, Input } from '@angular/core';

/**
 * Resumo de um caixa/PDV no design atual: identificação (caixa, operador, turno), métricas por forma de pagamento,
 * total em destaque e, abaixo, o conteúdo livre (ex.: tabela de vendas por produto).
 *
 * Uso: projetar `ss-cashier-field` com `identity`, `ss-kpi` com `stat` e `ss-kpi` com `total`.
 */
@Component({
  selector: 'ss-cashier-summary',
  template: `
    <section class="ss-cashier-summary">
      <div class="ss-cashier-summary__identity"><ng-content select="[identity]"></ng-content></div>
      <div class="ss-cashier-summary__stats"><ng-content select="[stat]"></ng-content></div>
      <div class="ss-cashier-summary__totals"><ng-content select="[total]"></ng-content></div>
      <ng-content></ng-content>
    </section>
  `,
  standalone: false
})
export class CashierSummaryComponent { }

@Component({
  selector: 'ss-cashier-field',
  template: `
    <span class="ss-cashier-field__label">{{ label }}</span>{{ ' ' }}<strong class="ss-cashier-field__value">{{ value || '—' }}</strong>
  `,
  host: { class: 'ss-cashier-field' },
  standalone: false
})
export class CashierFieldComponent {
  @Input() label = '';
  @Input() value: string | null | undefined = '';
}

@Component({
  selector: 'ss-cashier-section',
  template: `
    <section class="ss-cashier-summary__section">
      <h4 class="ss-cashier-summary__section-title">{{ title }}</h4>
      <ng-content></ng-content>
    </section>
  `,
  standalone: false
})
export class CashierSectionComponent {
  @Input() title = '';
}
